import * as angular from 'angular';

(function () {
    'use strict';

    angular.module('app').directive('eicValidator', eicValidator);

    /**
     * Validate EIC
     * Taken from JSF EicValidator
     *
     * @author flzemke.btc
     * @ngInject
     */
    function eicValidator() {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function (scope, element, attr, ctrl) {
                function eicValidator(ngModelValue) {
                    if (!ngModelValue || ngModelValue.length === 0) {
                        return true;
                    }

                    if (ngModelValue.length !== 16) {
                        return false;
                    }

                    //default EIC validation
                    var regExp = /[A-Za-z0-9]{2}X[A-Z-0-9]{13}$/;

                    //special validation for NWP EIC Codes
                    if (
                        !angular.isUndefined(attr.onlyNwpEic) &&
                        scope.$eval(attr.onlyNwpEic)
                    ) {
                        regExp = /[A-Z0-9]{2}[W-Z][A-Z-0-9]{13}$/;
                    }

                    return !!ngModelValue.match(regExp);
                }

                ctrl.$validators.eicValidator = eicValidator;
            }
        };
    }
})();
